import React from "react";
import { Col, Row } from "react-bootstrap";
import { DiJava, DiJavascript1, DiReact, DiNodejs, DiMongodb, DiGit, DiPython, DiHtml5, DiCss3, DiBootstrap } from "react-icons/di";
import { FaDatabase } from "react-icons/fa";
import { SiExpress, SiC } from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="Java"><DiJava /></Col>
      <Col xs={4} md={2} className="tech-icons" title="SQL / MySQL"><FaDatabase /></Col>
      <Col xs={4} md={2} className="tech-icons" title="JavaScript (Basics)"><DiJavascript1 /></Col>
      <Col xs={4} md={2} className="tech-icons" title="React"><DiReact /></Col>
      <Col xs={4} md={2} className="tech-icons" title="Node.js"><DiNodejs /></Col>
      <Col xs={4} md={2} className="tech-icons" title="Express.js"><SiExpress /></Col>
      <Col xs={4} md={2} className="tech-icons" title="MongoDB"><DiMongodb /></Col>
      <Col xs={4} md={2} className="tech-icons" title="Git"><DiGit /></Col>
      <Col xs={4} md={2} className="tech-icons" title="Python"><DiPython /></Col>
      <Col xs={4} md={2} className="tech-icons" title="C"><SiC /></Col>
      <Col xs={4} md={2} className="tech-icons" title="HTML5"><DiHtml5 /></Col>
      <Col xs={4} md={2} className="tech-icons" title="CSS3"><DiCss3 /></Col>
      <Col xs={4} md={2} className="tech-icons" title="Bootstrap"><DiBootstrap /></Col>
    </Row>
  );
}

export default Techstack;
